/**
 * Form Modal
 *
 * Opens the contact form modal when [data-open-form-modal] is clicked.
 * Supports per-button form override via data-form-override="#template-id".
 */
export function initFormModal() {
	const modal = document.getElementById("formModal");
	if (!modal) return;

	const backdrop    = modal.querySelector(".form-modal__backdrop");
	const closeBtn    = modal.querySelector(".form-modal__close");
	const formWrapper = modal.querySelector(".form-modal__cf7-wrapper");
	const triggers    = document.querySelectorAll("[data-open-form-modal]");

	const defaultFormHTML = formWrapper ? formWrapper.innerHTML : "";

	function swapForm(trigger) {
		const overrideSelector = trigger.dataset.formOverride;
		if (!overrideSelector || !formWrapper) return;
		const tpl = document.querySelector(overrideSelector);
		if (tpl) {
			formWrapper.innerHTML = tpl.innerHTML;
			if (typeof wpcf7 !== "undefined") {
				formWrapper.querySelectorAll(".wpcf7-form").forEach((f) => wpcf7.init(f));
			}
		}
	}

	function restoreForm() {
		if (!formWrapper) return;
		formWrapper.innerHTML = defaultFormHTML;
	}

	function open(trigger) {
		swapForm(trigger);
		modal.classList.add("is-open");
		document.body.style.overflow = "hidden";
		if (window.lenisInstance) window.lenisInstance.stop();
	}

	function close() {
		modal.classList.remove("is-open");
		document.body.style.overflow = "";
		if (window.lenisInstance) window.lenisInstance.start();
		restoreForm();
	}

	triggers.forEach((trigger) => {
		trigger.addEventListener("click", (e) => {
			e.preventDefault();
			open(trigger);
		});
	});

	if (backdrop) backdrop.addEventListener("click", close);
	if (closeBtn) closeBtn.addEventListener("click", close);

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") close();
	});
}
